import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/warehouses/:warehouseId/shelves/`;
const pathById = `${pathBase}:shelfId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const shelves = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  patch: apiPathFunc(pathById),
  delete: apiPathFunc(pathById),
};
